import { ChangeDetectionStrategy, Component, inject, input, InputSignal, output } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckBoxModule } from '@progress/kendo-angular-inputs';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, SwitchComponent, MapComponent } from '@ui/aos-lib';

import { EventsReportGroupModalService } from './report-group-modal.service';
import { ReportGroupCreateModalComponent } from '../../../../../pages/administration/report-groups/components/report-group-modal/report-group-modal.component';
import { TextareaComponent } from '../../../../../pages/administration/event-configuration/event-configuration-edit-window/textarea/textarea.component';
import { ReportGroupsFilterCriteriaComponent } from '../../../../../pages/administration/report-groups/components/report-groups-filter-criteria/report-groups-filter-criteria.component';
import { TranslateRegistry } from '../../../../../services/translate/translate.registry';
import { lassoDynamicFilterCommandToken } from '../../../../../pages/administration/report-groups/components/report-groups-filter-criteria/report-groups-dynamic-filter/dynamic-filters/lasso-dynamic-filter.component ';
import { ReportGroupModalService } from '../../../../../pages/administration/report-groups/components/report-group-modal/report-group-modal.service';
import { ReportGroupsCreationAPIBody } from 'src/app/pages/administration/report-groups/report-groups.types';

@Component({
  selector: 'aos-events-report-group-modal',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    CheckBoxModule,
    TextareaComponent,
    SwitchComponent,
    ReportGroupsFilterCriteriaComponent,
    MapComponent,
    TranslateModule,
    AsyncPipe
  ],
  templateUrl:
    '../../../../../pages/administration/report-groups/components/report-group-modal/report-group-modal.component.html',
  styleUrl:
    '../../../../../pages/administration/report-groups/components/report-group-modal/report-group-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ReportGroupModalService,
    EventsReportGroupModalService,
    {
      provide: lassoDynamicFilterCommandToken,
      useExisting: EventsReportGroupModalService
    }
  ]
})
export class EventsReportGroupModalComponent extends ReportGroupCreateModalComponent {
  readonly #eventsReportGroupModalService = inject(EventsReportGroupModalService);
  override canDelete: InputSignal<boolean> = input(false);
  create = output<ReportGroupsCreationAPIBody>();

  protected override get submitButtonText(): string {
    return TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.BUTTON.CREATE_REPORT_GROUP;
  }

  constructor() {
    super();
    this.#eventsReportGroupModalService.registerCommand(() => {
      this.closeWithRefresh.emit();
    });
  }

  override onSubmit(): void {
    this.closeWithRefresh.emit();
    this.create.emit(this.getReportGroupPayload(this.reportGroupsForm));
  }
}
